import { render } from "./TraqrScan.vue?vue&type=template&id=00c73bfb&lang=html"
import script from "./TraqrScan.vue?vue&type=script&lang=js"
export * from "./TraqrScan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__